import { axiosInstance } from "./axios";
import useCustomMutation from "hooks/useCustomMutation";
import useCustomQuery from "hooks/useCustomQuery";
import { IAddressBookAwaitingVerification } from "dto/ContactFormVerification/IAddressBookAwaitingVerification";
import { IMobywatelQRCodeResponse } from "dto/Activation/IMobywatelQRCodeResponse";

const queryKeys = {
  getVerification: (key: string) => [
    "contactFormVerificationService.getVerification",
    key,
  ],
};

const getVerification = (
  key
): Promise<{ data: IAddressBookAwaitingVerification }> => {
  const query = new URLSearchParams(window.location.search);

  query.append("key", key);

  return axiosInstance.get(`/contactformverification/verification?${query}`);
};

const useGetVerification = (key: string) => {
  return useCustomQuery(queryKeys.getVerification(key), () =>
    getVerification(key)
  );
};

const getMObywatelQRcode = (payload: {
  key: string;
  connectionId: string;
}): Promise<{
  data: IMobywatelQRCodeResponse;
}> => {
  const query = new URLSearchParams(window.location.search);

  query.append("key", payload.key);
  query.append("connectionId", payload.connectionId);

  return axiosInstance.get(`/contactformverification/qrcode?${query}`);
};

const useGetMObywatelQRcode = () => {
  return useCustomMutation(getMObywatelQRcode);
};

export default {
  useGetVerification,
  useGetMObywatelQRcode,
};
